/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Polygon } from './Polygon';
import {
    PolygonFromJSON,
    PolygonFromJSONTyped,
    PolygonToJSON,
} from './Polygon';

/**
 * 
 * @export
 * @interface AreaPost
 */
export interface AreaPost {
    /**
     * Point in time from when to extract the data. Default is now. NB!! Currently not used as only now is supported.
     * @type {string}
     * @memberof AreaPost
     */
    time?: string;
    /**
     * Duration back in time to show ships. Defaults to 24 hours = 24:00:00
     * @type {string}
     * @memberof AreaPost
     */
    timeout?: string;
    /**
     * 
     * @type {Polygon}
     * @memberof AreaPost
     */
    polygon?: Polygon;
}

/**
 * Check if a given object implements the AreaPost interface.
 */
export function instanceOfAreaPost(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AreaPostFromJSON(json: any): AreaPost {
    return AreaPostFromJSONTyped(json, false);
}

export function AreaPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): AreaPost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': !exists(json, 'time') ? undefined : json['time'],
        'timeout': !exists(json, 'timeout') ? undefined : json['timeout'],
        'polygon': !exists(json, 'polygon') ? undefined : PolygonFromJSON(json['polygon']),
    };
}

export function AreaPostToJSON(value?: AreaPost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': value.time,
        'timeout': value.timeout,
        'polygon': PolygonToJSON(value.polygon),
    };
}

